import { render, staticRenderFns } from "./GroupMobileMeals.vue?vue&type=template&id=0ce4be6d"
import script from "./GroupMobileMeals.vue?vue&type=script&lang=js"
export * from "./GroupMobileMeals.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports